import { Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import { QueryParam, Utils} from "lib-base";
import {Observable} from 'rxjs';
import { IChatResponse} from "../shared/interfaces/chat";
import {environment} from "../../environments/environment";
import {
  ChatAIResponse, IChatHistory,
  KPIChartData
} from "../shared/interfaces/database/chat-ia";

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private readonly baseUrl: string = `${environment.apiUrl}/api/mcp`;

  constructor(private http: HttpClient) {
  }

  simpleResponseTramites(question: string): Observable<ChatAIResponse> {
    const url = `${this.baseUrl}/tramites`;
    const params = new HttpParams().set('userInput', question);
    return this.http.get<ChatAIResponse>(url, {params: params }, );
  }

  simpleResponsePqrsdf(question: string): Observable<IChatResponse> {
    const url = `${this.baseUrl}/pqrsdf`;
    const params = new HttpParams().set('userInput', question);
    return this.http.get<IChatResponse>(url, {params: params});
  }

  getKPIChartData(consultaGraficaId: number): Observable<KPIChartData> {
    const url = `${this.baseUrl}/consulta-grafica/${consultaGraficaId}`;
    return this.http.get<KPIChartData>(url);
  }

  getKPIChartDataTest(identificador: number, filter: any): Observable<KPIChartData> {
    const url = `${this.baseUrl}/consulta/${identificador}/chart`;
    const params: QueryParam[] = [];
    Object.entries(filter).forEach(([key, value]) => {
      if (value != null || Array.isArray(value) && (value as any[])?.length > 0)
        params.push({key: key, value: value});
    })
    return this.http.get<KPIChartData>(Utils.createQueryParams(url, params))
  }


  getExcel(excelId: number):Observable<Blob> {
    const url = `${this.baseUrl}/consulta-excel/${excelId}/descargar`;
    return this.http.get(url, {responseType: "blob"});
  }

  cleanChatMemory(): Observable<boolean> {
    const url = `${this.baseUrl}/chat/historial`;
    return this.http.delete<boolean>(url);
  }

  getChatMemory(): Observable<IChatHistory[]> {
    const url = `${this.baseUrl}/chat/historial`;
    return this.http.get<IChatHistory[]>(url);
  }
}
